import { render, staticRenderFns } from "./ExperimentFiles.vue?vue&type=template&id=8470d0e2&"
import script from "./ExperimentFiles.vue?vue&type=script&lang=js&"
export * from "./ExperimentFiles.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/experiment/ExperimentFiles/ExperimentFilesStyle.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports